module.exports = __webpack_public_path__ + "static/media/seeds-of-life-thumbnail_mobile.1d6de625.jpg";